import { defineComponent as _defineComponent } from 'vue'

import commonProps from "../props/commonProps";

export interface TextInputFormatter {
  format: (value: string) => string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'InputCustom',
  props: {
  ...commonProps,
  textInputFormatters: {
    type: Array as () => TextInputFormatter[],
    default: () => [],
  },
},
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

const applyFormatters = (value: string) => {
  return props.textInputFormatters.reduce((formattedValue, formatter) => {
    return formatter.format(formattedValue);
  }, value);
};

const handleInput = (event: Event) => {
  const target = event.target as HTMLInputElement;
  let value = target.value;
  const maxAttr = target.getAttribute("maxlength");
  const maxLength = maxAttr ? Number(maxAttr) : target.maxLength;
  if (maxLength > 0 && value.length > maxLength) {
    value = value.slice(0, maxLength);
    target.value = value;
  }
  const formattedValue = applyFormatters(value);
  emit("update:modelValue", formattedValue);
};

const __returned__ = { props, emit, applyFormatters, handleInput }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})